import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'EDIT_REMINDER_DIALOG';

export const editReminderDialog = createAction(
  rootUiActions.createDialog.toString(),
  (txn: TransactionRecord, context: string, otherProps?: any) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      allowNesting: true,
      id: `EDIT_REMINDER_${txn?.id || '0'}`,
      props: ImmutableMap({
        txn,
        context,
        otherProps,
        dialogId: `EDIT_REMINDER_${txn?.id || '0'}`,
      }),
    }),
);
